import MediaDetails from './MediaDetails';

export default MediaDetails;
